import client from './inventory-request';
import { withStoreCreateBody, getStoreActorId } from '../hooks/useStoreScope';

function vendorReturnScopeParams(scope = {}) {
  const params = {};
  if (scope.tenant_id) params.tenant_id = scope.tenant_id;
  if (scope.hospital_id) params.hospital_id = scope.hospital_id;
  return params;
}

// Vendor Returns (grn-batch-service)
// API: GET /inventory/vendor-returns/ — tenant_id/hospital_id required;
// optional filters: vendor_id, source_grn_id, return_type, status, limit, offset
export const getVendorReturns = (scope = {}, filters = {}) =>
  client.get('/inventory/vendor-returns/', { ...vendorReturnScopeParams(scope), ...filters });

// API: GET /inventory/vendor-returns/{id}/
export const getVendorReturn = (id, scope = {}) =>
  client.get(`/inventory/vendor-returns/${id}/`, vendorReturnScopeParams(scope));

// API: POST /inventory/vendor-returns/ (201)
// Precondition: source_grn.status must be POSTED_TO_STOCK.
// return_type = REPLACEMENT auto-sets each line's replacement_status = AWAITING.
export const createVendorReturn = (body) => client.post('/inventory/vendor-returns/', withStoreCreateBody(body));

// API: POST /inventory/vendor-returns/{id}/confirm/ — same endpoint for REFUND and REPLACEMENT
export const confirmVendorReturn = (id, opts = {}, scope = {}) => {
  const body = {};
  const actor = opts.confirmed_by || getStoreActorId();
  if (actor) body.confirmed_by = actor;
  return client.post(`/inventory/vendor-returns/${id}/confirm/`, body, vendorReturnScopeParams(scope));
};

// API: POST /inventory/vendor-returns/{id}/cancel/ — reason is required
export const cancelVendorReturn = (id, opts = {}, scope = {}) => {
  const body = { reason: opts.reason || '' };
  const actor = opts.cancelled_by || getStoreActorId();
  if (actor) body.cancelled_by = actor;
  return client.post(`/inventory/vendor-returns/${id}/cancel/`, body, vendorReturnScopeParams(scope));
};

// API: GET /inventory/vendor-returns/awaiting-replacement/ — REPLACEMENT-type lines
// still replacement_status = AWAITING, across all vendor returns in scope.
export const getAwaitingReplacementVendorReturns = (scope = {}) =>
  client.get('/inventory/vendor-returns/awaiting-replacement/', vendorReturnScopeParams(scope));
